import React, { Component } from 'react';
import PassengerTicket from './PassengerTicket';
import {connect} from "react-redux";
import { Redirect }  from "react-router-dom";
import aprovalImg from '../../assets/approval.png'
import ticketImg from '../../assets/ticket.png'
import PriceTotal from "./PriceTotal";
import { registerRemissionConfirmationViewedEvent } from "../../actions/reissueActions";

const CONFIRMATION_TITLE = '¡Remisión realizada!';
const CONFIRMATION_COPY_PENDING = 'La operación fue registrada correctamente.';
const CONFIRMATION_COPY_AVAILABLE = 'La operación fue registrada correctamente y los tickets se encuentran disponibles.';
const PENDING_ALERT_TITLE = 'Contacte al Counter de Costamar';
const PENDING_ALERT_MESSAGE = 'La remisión fue completada; sin embargo, los TKT aún no se encuentran disponibles.';
const PENDING_ALERT_ACTION = 'Por favor, contacte al Counter de Costamar para la entrega de sus tickets y la confirmación de la remisión.';

const getEmissionView = (reissueReducer) => {
    const reservation = reissueReducer?.emissionRS?.successAndWarningsAndAirReservation?.[0] || {};
    const tickets = (reservation.ticketing || []).filter(ticket => ticket);
    const hasTickets = tickets.length > 0;
    const hasPendingTickets = !hasTickets || tickets.some(ticket =>
        !ticket.ticketDocumentNbr || (!ticket.document && !ticket.downloadRequest)
    );

    return { reservation, tickets, hasTickets, hasPendingTickets };
};

// Solo evidencia visual: no se envían datos de pago ni de pasajeros.
const buildConfirmationViewedEventRQ = (view, travelItineraryRS) => {
    const downloadRequest = view.tickets.find(ticket => ticket.downloadRequest)?.downloadRequest || {};
    const ticketNumbers = view.tickets
        .map(ticket => ticket.ticketDocumentNbr)
        .filter(ticketNumber => ticketNumber);

    return {
        recordLocator: downloadRequest.recordLocator || travelItineraryRS?.pnr || null,
        orderId: downloadRequest.orderId || travelItineraryRS?.orderId || null,
        transactionId: null,
        screen: '/emission',
        component: 'EmissionResult',
        viewed: true,
        viewedAt: new Date().toISOString(),
        outcome: ticketNumbers.length > 0 ? 'SUCCESS_WITH_TICKET' : 'SUCCESS_WITHOUT_TICKET',
        ticketCount: ticketNumbers.length,
        ticketNumbers,
        messageShown: `${CONFIRMATION_TITLE} ${view.hasPendingTickets ? CONFIRMATION_COPY_PENDING : CONFIRMATION_COPY_AVAILABLE}`,
        warningShown: view.hasPendingTickets
            ? `${PENDING_ALERT_TITLE}. ${PENDING_ALERT_MESSAGE} ${PENDING_ALERT_ACTION}`
            : null
    };
};

class Emission extends Component {
    onClick = () => (
        <Redirect to='/home'/>
    );

    componentDidMount() {
        this.registerConfirmationViewed();
    }

    registerConfirmationViewed() {
        const { reissueReducer, bookingInformationReducer } = this.props;
        if (this.confirmationViewedRegistered || !reissueReducer?.success) {
            return;
        }

        this.confirmationViewedRegistered = true;
        // Sin await: el registro no debe bloquear ni afectar la vista
        registerRemissionConfirmationViewedEvent(buildConfirmationViewedEventRQ(
            getEmissionView(reissueReducer),
            bookingInformationReducer?.travelItineraryRS
        ));
    }

    render() {
        //console.log(this.props);
        const { success } = this.props.reissueReducer;
        const { pnr } = (this.props?.travelItineraryRS) ? this.props?.travelItineraryRS : {pnr: ''};
        const { reservation, tickets, hasTickets, hasPendingTickets } = getEmissionView(this.props.reissueReducer);
        if(!success) { return (<Redirect to='/home'/>)}
        return (
            <div className="EmissionResult emission-result row">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 col-12 mx-auto success-emission text-center">
                            <h4 className="Zeticketing-title mt-3 pb-3">RESULTADO DE REMISIÓN</h4>
                            <div className={`emission-confirmation ${hasPendingTickets ? 'emission-confirmation-pending' : ''}`}>
                                <img className="emission-confirmation-icon" src={aprovalImg} alt="Remisión realizada"/>
                                <p className="emission-confirmation-title">{CONFIRMATION_TITLE}</p>
                                <p className="emission-confirmation-copy">
                                    {hasPendingTickets ? CONFIRMATION_COPY_PENDING : CONFIRMATION_COPY_AVAILABLE}
                                </p>
                                <p className="emission-confirmation-pnr">PNR: <span><strong>{pnr}</strong></span></p>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-10 col-12 mx-auto">
                            {
                                hasPendingTickets ? (
                                    <div className="alert alert-warning pending-ticket-alert" role="alert">
                                        <div className="pending-ticket-alert-icon">
                                            <i className="bi bi-headset" aria-hidden="true"></i>
                                        </div>
                                        <div>
                                            <h2 className='h5 pending-ticket-alert-title'>{PENDING_ALERT_TITLE}</h2>
                                            <p className='mb-2'>{PENDING_ALERT_MESSAGE}</p>
                                            <p className='mb-0 pending-ticket-alert-action'>{PENDING_ALERT_ACTION}</p>
                                        </div>
                                    </div>
                                ) : ''
                            }
                            {
                                hasTickets ? (
                                        <div className="EmissionResult row">
                                            <div className="col-md-12">
                                                <div className="container-box tickets-panel">
                                                    <h4 className="mb-3">
                                                        <img src={ticketImg} alt="" width="30"/>
                                                        <strong>Tickets</strong>
                                                    </h4>
                                                    <div className="PassengersInformation row">
                                                        <div className="col-md-12">
                                                            <table className="table table-condensed">
                                                                <thead>
                                                                <th>NOMBRES</th>
                                                                {/*<th>APELLIDOS</th>*/}
                                                                <th>NÚMERO DE TICKET</th>
                                                                {/*<th>NÚMERO DE INVOICE</th>*/}
                                                                <th></th>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                    tickets.map((ticket, index) => {
                                                                        if(!ticket){
                                                                            return null
                                                                        } else{
                                                                            return (<PassengerTicket key={ticket.ticketDocumentNbr || index} ticket={ticket} />)
                                                                        }
                                                                    })
                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                ) : ''
                            }
                            {
                                reservation?.priceInfo ? (
                                    <PriceTotal pricing={reservation.priceInfo}/>
                                ) : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

function mapStateToProps({ bookingInformationReducer, reissueReducer }){
    return { bookingInformationReducer, reissueReducer }
}

export default connect(mapStateToProps)(Emission);
